module.exports = __webpack_public_path__ + "assets/img/theX-content-10.c90f9900.png";